import { TestDefinition, QuestionType } from '../../types';

// Helper scales
const vanderbiltFrequency = [
  { label: 'Nunca', value: 0 },
  { label: 'Ocasionalmente', value: 1 },
  { label: 'A menudo', value: 2 },
  { label: 'Muy a menudo', value: 3 }
];

const vanderbiltPerformance = [
  { label: 'Excelente', value: 1 },
  { label: 'Superior al promedio', value: 2 },
  { label: 'Promedio', value: 3 },
  { label: 'Algo problemático', value: 4 },
  { label: 'Problemático', value: 5 }
];

const sdqScale = [
  { label: 'No es cierto', value: 0 },
  { label: 'Un tanto cierto', value: 1 },
  { label: 'Absolutamente cierto', value: 2 }
];

const asrsScale = [
  { label: 'Nunca', value: 0 },
  { label: 'Rara vez', value: 1 },
  { label: 'A veces', value: 2 },
  { label: 'A menudo', value: 3 },
  { label: 'Muy a menudo', value: 4 }
];

export const TESTS_PEDIATRICO_TDAH: TestDefinition[] = [
  {
    id: 'vanderbilt-parent',
    code: 'Vanderbilt-P',
    name: 'Vanderbilt ADHD Parent Rating Scale (Versión Breve)',
    category: 'TDAH / Pediátrico',
    description: 'Escala de 27 ítems para screening de TDAH en niños de 6-12 años. Completada por padres. Evalúa síntomas de inatención, hiperactividad e impulsividad según criterios DSM.',
    excludeFromTotal: ['v19', 'v20', 'v21', 'v22', 'v23', 'v24', 'v25', 'v26', 'v27'],
    questions: [
      // INATENCIÓN (9 ítems)
      {
        id: 'v1',
        text: '1. No presta atención a detalles o comete errores por descuido',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inatención'
      },
      {
        id: 'v2',
        text: '2. Tiene dificultad para mantener la atención en tareas',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inatención'
      },
      {
        id: 'v3',
        text: '3. No parece escuchar cuando se le habla directamente',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inatención'
      },
      {
        id: 'v4',
        text: '4. No sigue instrucciones y no termina tareas escolares',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inatención'
      },
      {
        id: 'v5',
        text: '5. Tiene dificultad para organizar tareas y actividades',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inatención'
      },
      {
        id: 'v6',
        text: '6. Evita tareas que requieren esfuerzo mental sostenido',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inatención'
      },
      {
        id: 'v7',
        text: '7. Pierde cosas necesarias para tareas o actividades',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inatención'
      },
      {
        id: 'v8',
        text: '8. Se distrae fácilmente por estímulos irrelevantes',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inatención'
      },
      {
        id: 'v9',
        text: '9. Es olvidadizo en actividades diarias',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Inatención'
      },

      // HIPERACTIVIDAD/IMPULSIVIDAD (9 ítems)
      {
        id: 'v10',
        text: '10. Mueve manos o pies o se retuerce en el asiento',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hiperactividad/Impulsividad'
      },
      {
        id: 'v11',
        text: '11. Abandona su asiento cuando se espera que permanezca sentado',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hiperactividad/Impulsividad'
      },
      {
        id: 'v12',
        text: '12. Corre o trepa en situaciones inapropiadas',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hiperactividad/Impulsividad'
      },
      {
        id: 'v13',
        text: '13. Tiene dificultad para jugar tranquilamente',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hiperactividad/Impulsividad'
      },
      {
        id: 'v14',
        text: '14. Está "en marcha" o actúa como si tuviera un motor',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hiperactividad/Impulsividad'
      },
      {
        id: 'v15',
        text: '15. Habla excesivamente',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hiperactividad/Impulsividad'
      },
      {
        id: 'v16',
        text: '16. Responde antes de que se terminen de formular las preguntas',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hiperactividad/Impulsividad'
      },
      {
        id: 'v17',
        text: '17. Tiene dificultad para esperar su turno',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hiperactividad/Impulsividad'
      },
      {
        id: 'v18',
        text: '18. Interrumpe o se entromete en asuntos de otros',
        type: QuestionType.LIKERT,
        options: vanderbiltFrequency,
        subscale: 'Hiperactividad/Impulsividad'
      },

      // DESEMPEÑO ACADÉMICO (8 ítems)
      {
        id: 'v19',
        text: '19. Desempeño en lectura',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Desempeño Académico'
      },
      {
        id: 'v20',
        text: '20. Desempeño en matemáticas',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Desempeño Académico'
      },
      {
        id: 'v21',
        text: '21. Desempeño en escritura',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Desempeño Académico'
      },
      {
        id: 'v22',
        text: '22. Relación con compañeros',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Desempeño Social'
      },
      {
        id: 'v23',
        text: '23. Participación en actividades organizadas',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Desempeño Social'
      },
      {
        id: 'v24',
        text: '24. Seguimiento de órdenes en casa',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Desempeño en Casa'
      },
      {
        id: 'v25',
        text: '25. Relación con padres',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Desempeño en Casa'
      },
      {
        id: 'v26',
        text: '26. Relación con hermanos',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Desempeño en Casa'
      },
      {
        id: 'v27',
        text: '27. Asignación de responsabilidades en casa',
        type: QuestionType.LIKERT,
        options: vanderbiltPerformance,
        subscale: 'Desempeño en Casa'
      }
    ],
    subscales: [
      {
        name: 'Inatención',
        questionIds: ['v1', 'v2', 'v3', 'v4', 'v5', 'v6', 'v7', 'v8', 'v9'],
        description: 'Síntomas de déficit de atención (≥6 ítems con 2-3 sugiere TDAH inatento)'
      },
      {
        name: 'Hiperactividad/Impulsividad',
        questionIds: ['v10', 'v11', 'v12', 'v13', 'v14', 'v15', 'v16', 'v17', 'v18'],
        description: 'Síntomas de hiperactividad e impulsividad (≥6 ítems con 2-3 sugiere TDAH hiperactivo)'
      },
      {
        name: 'Desempeño Académico',
        questionIds: ['v19', 'v20', 'v21'],
        description: 'Funcionamiento en áreas académicas'
      },
      {
        name: 'Desempeño Social',
        questionIds: ['v22', 'v23'],
        description: 'Funcionamiento social con pares'
      },
      {
        name: 'Desempeño en Casa',
        questionIds: ['v24', 'v25', 'v26', 'v27'],
        description: 'Funcionamiento en el hogar'
      }
    ],
    interpretations: [
      { min: 0, max: 13, label: 'Síntomas TDAH Bajos', color: 'bg-green-100 text-green-800' },
      { min: 14, max: 27, label: 'Síntomas TDAH Leves', color: 'bg-yellow-100 text-yellow-800' },
      { min: 28, max: 40, label: 'Síntomas TDAH Moderados - Evaluación Requerida', color: 'bg-orange-100 text-orange-800' },
      { min: 41, max: 54, label: 'Síntomas TDAH Severos - Evaluación Urgente', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'sdq',
    code: 'SDQ',
    name: 'Strengths and Difficulties Questionnaire',
    category: 'TDAH / Pediátrico',
    description: 'Cuestionario de 25 ítems para screening de psicopatología infantil (4-17 años). Desarrollado por Goodman (1997). Evalúa 5 dimensiones: problemas emocionales, conductuales, hiperactividad, relacionales y conducta prosocial.',
    excludeFromTotal: ['s21', 's22', 's23', 's24', 's25'],
    questions: [
      // SÍNTOMAS EMOCIONALES (5 ítems)
      {
        id: 's1',
        text: '1. A menudo se queja de dolores de cabeza, estómago o náuseas',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Síntomas Emocionales'
      },
      {
        id: 's2',
        text: '2. Tiene muchas preocupaciones o a menudo parece preocupado',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Síntomas Emocionales'
      },
      {
        id: 's3',
        text: '3. A menudo está descontento, triste o lloroso',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Síntomas Emocionales'
      },
      {
        id: 's4',
        text: '4. Es nervioso o dependiente ante situaciones nuevas',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Síntomas Emocionales'
      },
      {
        id: 's5',
        text: '5. Tiene muchos miedos, se asusta fácilmente',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Síntomas Emocionales'
      },

      // PROBLEMAS DE CONDUCTA (5 ítems)
      {
        id: 's6',
        text: '6. A menudo tiene rabietas o mal genio',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Problemas de Conducta'
      },
      {
        id: 's7',
        text: '7. Generalmente es obediente, hace lo que le piden',
        type: QuestionType.LIKERT,
        options: [
          { label: 'No es cierto', value: 2 },
          { label: 'Un tanto cierto', value: 1 },
          { label: 'Absolutamente cierto', value: 0 }
        ],
        subscale: 'Problemas de Conducta'
      },
      {
        id: 's8',
        text: '8. A menudo pelea con otros niños o los intimida',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Problemas de Conducta'
      },
      {
        id: 's9',
        text: '9. A menudo miente o hace trampa',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Problemas de Conducta'
      },
      {
        id: 's10',
        text: '10. Roba en casa, en la escuela o en otros lugares',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Problemas de Conducta'
      },

      // HIPERACTIVIDAD (5 ítems)
      {
        id: 's11',
        text: '11. Es inquieto, hiperactivo, no se puede estar quieto por mucho tiempo',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Hiperactividad'
      },
      {
        id: 's12',
        text: '12. Está continuamente moviéndose o es impulsivo',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Hiperactividad'
      },
      {
        id: 's13',
        text: '13. Se distrae fácilmente, su concentración tiende a dispersarse',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Hiperactividad'
      },
      {
        id: 's14',
        text: '14. Piensa antes de actuar',
        type: QuestionType.LIKERT,
        options: [
          { label: 'No es cierto', value: 2 },
          { label: 'Un tanto cierto', value: 1 },
          { label: 'Absolutamente cierto', value: 0 }
        ],
        subscale: 'Hiperactividad'
      },
      {
        id: 's15',
        text: '15. Termina lo que empieza, buena concentración',
        type: QuestionType.LIKERT,
        options: [
          { label: 'No es cierto', value: 2 },
          { label: 'Un tanto cierto', value: 1 },
          { label: 'Absolutamente cierto', value: 0 }
        ],
        subscale: 'Hiperactividad'
      },

      // PROBLEMAS CON PARES (5 ítems)
      {
        id: 's16',
        text: '16. Es más bien solitario, tiende a jugar solo',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Problemas con Pares'
      },
      {
        id: 's17',
        text: '17. Tiene al menos un buen amigo',
        type: QuestionType.LIKERT,
        options: [
          { label: 'No es cierto', value: 2 },
          { label: 'Un tanto cierto', value: 1 },
          { label: 'Absolutamente cierto', value: 0 }
        ],
        subscale: 'Problemas con Pares'
      },
      {
        id: 's18',
        text: '18. Generalmente cae bien a otros niños',
        type: QuestionType.LIKERT,
        options: [
          { label: 'No es cierto', value: 2 },
          { label: 'Un tanto cierto', value: 1 },
          { label: 'Absolutamente cierto', value: 0 }
        ],
        subscale: 'Problemas con Pares'
      },
      {
        id: 's19',
        text: '19. Los otros niños lo molestan o se meten con él',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Problemas con Pares'
      },
      {
        id: 's20',
        text: '20. Se lleva mejor con adultos que con otros niños',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Problemas con Pares'
      },

      // CONDUCTA PROSOCIAL (5 ítems)
      {
        id: 's21',
        text: '21. Es considerado con los sentimientos de otros',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Conducta Prosocial'
      },
      {
        id: 's22',
        text: '22. Comparte frecuentemente con otros niños',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Conducta Prosocial'
      },
      {
        id: 's23',
        text: '23. Es servicial si alguien está herido, molesto o enfermo',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Conducta Prosocial'
      },
      {
        id: 's24',
        text: '24. Es amable con niños más pequeños',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Conducta Prosocial'
      },
      {
        id: 's25',
        text: '25. A menudo se ofrece para ayudar a otros',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Conducta Prosocial'
      }
    ],
    subscales: [
      {
        name: 'Síntomas Emocionales',
        questionIds: ['s1', 's2', 's3', 's4', 's5'],
        description: 'Ansiedad, depresión, quejas somáticas'
      },
      {
        name: 'Problemas de Conducta',
        questionIds: ['s6', 's7', 's8', 's9', 's10'],
        description: 'Conducta oposicionista, agresividad, mentiras'
      },
      {
        name: 'Hiperactividad',
        questionIds: ['s11', 's12', 's13', 's14', 's15'],
        description: 'Inatención, hiperactividad, impulsividad'
      },
      {
        name: 'Problemas con Pares',
        questionIds: ['s16', 's17', 's18', 's19', 's20'],
        description: 'Dificultades en relaciones sociales'
      },
      {
        name: 'Conducta Prosocial',
        questionIds: ['s21', 's22', 's23', 's24', 's25'],
        description: 'Fortaleza: empatía, colaboración, ayuda'
      }
    ],
    interpretations: [
      { min: 0, max: 13, label: 'Normal - Bajo Riesgo', color: 'bg-green-100 text-green-800' },
      { min: 14, max: 16, label: 'Límite - Monitorear', color: 'bg-yellow-100 text-yellow-800' },
      { min: 17, max: 40, label: 'Anormal - Evaluación Requerida', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'cbcl-brief',
    code: 'CBCL-25',
    name: 'Child Behavior Checklist (Versión Ultra-Breve 25 ítems)',
    category: 'TDAH / Pediátrico',
    description: 'Versión ultra-breve del CBCL para screening de problemas conductuales y emocionales en niños de 6-18 años. Completada por padres. Evalúa problemas internalizantes (ansiedad, depresión) y externalizantes (agresión, conducta oposicionista).',
    questions: [
      // PROBLEMAS INTERNALIZANTES (12 ítems)
      {
        id: 'c1',
        text: '1. Actúa muy joven para su edad',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c2',
        text: '2. Se queja de soledad',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c3',
        text: '3. Llora mucho',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c4',
        text: '4. Miedos o ansiedades',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c5',
        text: '5. Necesita ser perfecto',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c6',
        text: '6. Se siente sin valor o inferior',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c7',
        text: '7. Nervioso, tenso',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c8',
        text: '8. Demasiado miedoso o ansioso',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c9',
        text: '9. Infeliz, triste o deprimido',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c10',
        text: '10. Retraído, no se involucra con otros',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c11',
        text: '11. Se preocupa',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },
      {
        id: 'c12',
        text: '12. Quejas somáticas sin causa médica conocida',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Internalizante'
      },

      // PROBLEMAS EXTERNALIZANTES (13 ítems)
      {
        id: 'c13',
        text: '13. Discute mucho',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c14',
        text: '14. Crueldad, intimidación o maldad hacia otros',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c15',
        text: '15. Desobediente en casa',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c16',
        text: '16. Desobediente en la escuela',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c17',
        text: '17. Se mete en muchas peleas',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c18',
        text: '18. Ataca físicamente a la gente',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c19',
        text: '19. Grita mucho',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c20',
        text: '20. Habla demasiado',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c21',
        text: '21. Hace rabietas o tiene mal genio',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c22',
        text: '22. Amenaza a la gente',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c23',
        text: '23. Inusualmente ruidoso',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c24',
        text: '24. Destruye sus propias cosas',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      },
      {
        id: 'c25',
        text: '25. Destruye cosas que pertenecen a su familia u otros',
        type: QuestionType.LIKERT,
        options: sdqScale,
        subscale: 'Externalizante'
      }
    ],
    subscales: [
      {
        name: 'Problemas Internalizantes',
        questionIds: ['c1', 'c2', 'c3', 'c4', 'c5', 'c6', 'c7', 'c8', 'c9', 'c10', 'c11', 'c12'],
        description: 'Ansiedad, depresión, retraimiento, quejas somáticas'
      },
      {
        name: 'Problemas Externalizantes',
        questionIds: ['c13', 'c14', 'c15', 'c16', 'c17', 'c18', 'c19', 'c20', 'c21', 'c22', 'c23', 'c24', 'c25'],
        description: 'Agresión, conducta oposicionista, conducta disruptiva'
      }
    ],
    interpretations: [
      { min: 0, max: 15, label: 'Rango Normal', color: 'bg-green-100 text-green-800' },
      { min: 16, max: 23, label: 'Rango Límite - Monitorear', color: 'bg-yellow-100 text-yellow-800' },
      { min: 24, max: 50, label: 'Rango Clínico - Evaluación Requerida', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'asrs-v1.1',
    code: 'ASRS',
    name: 'Adult ADHD Self-Report Scale (ASRS-v1.1) Screener',
    category: 'TDAH / Pediátrico',
    description: 'Escala breve de 6 ítems para screening de TDAH en adultos. Desarrollada por la OMS y Kessler et al. (2005). Los primeros 4 ítems son los más predictivos. Puntuación ≥4 sugiere alta probabilidad de TDAH.',
    questions: [
      {
        id: 'a1',
        text: '1. ¿Con qué frecuencia tiene problemas para terminar los detalles finales de un proyecto, una vez que ya se hicieron las partes difíciles?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Inatención'
      },
      {
        id: 'a2',
        text: '2. ¿Con qué frecuencia tiene dificultades para hacer tareas que requieren organización?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Inatención'
      },
      {
        id: 'a3',
        text: '3. ¿Con qué frecuencia tiene problemas para recordar citas u obligaciones?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Inatención'
      },
      {
        id: 'a4',
        text: '4. Cuando tiene una tarea que requiere mucho pensamiento, ¿con qué frecuencia evita o retrasa el inicio?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Inatención'
      },
      {
        id: 'a5',
        text: '5. ¿Con qué frecuencia mueve o retuerce las manos o los pies cuando tiene que estar sentado durante mucho tiempo?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Hiperactividad/Impulsividad'
      },
      {
        id: 'a6',
        text: '6. ¿Con qué frecuencia se siente demasiado activo/a y obligado/a a hacer cosas, como si lo/la moviera un motor?',
        type: QuestionType.LIKERT,
        options: asrsScale,
        subscale: 'Hiperactividad/Impulsividad'
      }
    ],
    subscales: [
      {
        name: 'Inatención',
        questionIds: ['a1', 'a2', 'a3', 'a4'],
        description: 'Dificultades atencionales y organizativas (ítems más predictivos)'
      },
      {
        name: 'Hiperactividad/Impulsividad',
        questionIds: ['a5', 'a6'],
        description: 'Inquietud motora y sensación de ser empujado por un motor'
      }
    ],
    interpretations: [
      { min: 0, max: 13, label: 'Screening Negativo', color: 'bg-green-100 text-green-800' },
      { min: 14, max: 24, label: 'Alta Probabilidad de TDAH - Evaluación Completa Requerida', color: 'bg-red-200 text-red-900' }
    ]
  }
];
